/**
 * Simple, elegant SVG dental chart (Universal numbering 1-32).
 * "affected" is a list of { tooth, status } where status: planned|in_progress|completed
 */
export default function DentalChart({ affected = [] }) {
  const statusOf = (n) => affected.find((a) => String(a.tooth) === String(n))?.status;
  const color = (s) => s === "completed" ? "#B89C81" : s === "in_progress" ? "#D06A42" : s === "planned" ? "#4A6B5D" : "#F5F3ED";
  const stroke = (s) => s ? "#1A362B" : "#D6C4B0";

  const upper = Array.from({ length: 16 }, (_, i) => i + 1);
  const lower = Array.from({ length: 16 }, (_, i) => 32 - i);

  const Tooth = ({ n }) => {
    const s = statusOf(n);
    return (
      <div className="flex flex-col items-center gap-1">
        <div className="w-8 h-10 rounded-t-full rounded-b-md border-2 grid place-items-center text-[10px] font-mono transition-all hover:scale-105"
             style={{ background: color(s), borderColor: stroke(s), color: s === "completed" ? "#fff" : "#1A362B" }}
             data-testid={`tooth-${n}`}>
          {n}
        </div>
      </div>
    );
  };

  return (
    <div className="space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-widest text-ink-soft mb-2">Upper</div>
        <div className="flex gap-1 justify-between">{upper.map((n) => <Tooth key={n} n={n} />)}</div>
      </div>
      <div>
        <div className="text-[10px] uppercase tracking-widest text-ink-soft mb-2">Lower</div>
        <div className="flex gap-1 justify-between">{lower.map((n) => <Tooth key={n} n={n} />)}</div>
      </div>
      <div className="flex gap-4 text-xs text-ink-mid pt-2 border-t border-[#E8EAE9]">
        <span className="inline-flex items-center gap-1"><span className="w-3 h-3 rounded-sm bg-[#B89C81] inline-block" />Completed</span>
        <span className="inline-flex items-center gap-1"><span className="w-3 h-3 rounded-sm bg-[#D06A42] inline-block" />In progress</span>
        <span className="inline-flex items-center gap-1"><span className="w-3 h-3 rounded-sm bg-[#4A6B5D] inline-block" />Planned</span>
      </div>
    </div>
  );
}
